import React from 'react';
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faScissors, faExclamationTriangle, faChartLine, faBalanceScale, faRulerCombined, faArrowUp, faCogs, faPercent, faCode, faProjectDiagram, faLightbulb, faExplosion, faBook } from '@fortawesome/free-solid-svg-icons';
import { faNodeJs, faAngular } from '@fortawesome/free-brands-svg-icons';

const blogs = [
    {
        title: "Node.js: The Backbone of Scalable Web Applications in 2025",
        description: "Discover why Node.js remains a top choice for building scalable and efficient web applications in 2025.",
        icon: faNodeJs,
        link: "/blogs/node-is-backbone",
        datePublished: "2025-01-01",
        keywords: "Node.js, scalable web applications, backend development, event-driven, non-blocking I/O, microservices, NPM, serverless, cloud-native, node.js scalability patterns, high performance nodejs APIs, Anmatics Technologies"
    },
    {
        title: "What is Deckle Matching? A Complete Guide for Paper Manufacturers",
        description: "Learn everything about deckle matching and its importance in paper manufacturing.",
        icon: faBookOpen,
        link: "/blogs/deckle-matching-guide",
        datePublished: "2025-06-01",
        keywords: "Deckle matching, paper manufacturing, deckle matching software, paper mill trim waste, reduce trim waste in slitting machines, deckle matching best practices, deckle matching case study, Anmatics Technologies"
    },
    {
        title: "Modernizing Legacy Applications with .NET Core: A Step-by-Step Guide",
        description: "Learn how to successfully modernize your legacy applications using .NET Core with this comprehensive step-by-step guide.",
        icon: faCogs,
        link: "/blogs/modernizing-legacy-with-dotnet-core",
        datePublished: "2025-05-20",
        keywords: ".NET Core modernization, legacy system upgrade, migrate to .NET Core, .NET Core migration roadmap, zero-downtime migration, cloud migration, microservices, enterprise modernization, Anmatics Technologies"
    },
    {
        title: "How to Reduce Trim Waste in Paper Roll Cutting Processes",
        description: "Effective strategies to minimize trim waste and boost your mill’s profitability.",
        icon: faScissors,
        link: "/blogs/reduce-trim-waste",
        datePublished: "2025-06-10",
        keywords: "Trim waste reduction, paper roll cutting, paper mill efficiency, deckle matching, Anmatics Technologies"
    },
    {
        title: "Why Angular Is Still the Most Reliable Framework for Enterprise Web Applications in 2025",
        description: "Angular offers stability, scalability, and maintainability for large, mission-critical enterprise web applications. See why it's trusted by Fortune 500 companies.",
        icon: faAngular,
        link: "/blogs/angular-most-reliable-framework",
        datePublished: "2025-07-15",
        keywords: "Angular, enterprise web applications, frontend framework, scalable apps, Angular CLI, RxJS, SSR, Angular Universal, long-term support, Anmatics Technologies"
    },
    {
        title: "Top 5 Mistakes in Reel Slitting Operations and How to Avoid Them",
        description: "Avoid common errors in reel slitting and improve your production efficiency.",
        icon: faExclamationTriangle,
        link: "/blogs/mistakes-in-reel-slitting",
        datePublished: "2025-06-20",
        keywords: "Reel slitting mistakes, paper mill operations, production efficiency, Anmatics Technologies"
    },
    {
        title: "Why Deckle Matching Optimization Can Save Lakhs in Production Costs",
        description: "Discover how optimizing deckle matching can lead to significant cost savings.",
        icon: faChartLine,
        link: "/blogs/deckle-matching-optimization",
        datePublished: "2025-07-01",
        keywords: "Deckle matching optimization, production cost savings, paper mill software, Anmatics Technologies"
    },
    {
        title: "Manual vs. Software-Based Deckle Matching: A Cost-Benefit Analysis",
        description: "Compare manual and software-based deckle matching for better decision making.",
        icon: faBalanceScale,
        link: "/blogs/manual-vs-software-deckle-matching",
        datePublished: "2025-07-10",
        keywords: "Manual deckle matching, software deckle matching, cost-benefit analysis, paper mill, Anmatics Technologies"
    },
    {
        title: "Understanding GSM, Deckle Size, and Knife Limits in Paper Roll Planning",
        description: "A guide to GSM, deckle size, and knife limits for efficient paper roll planning.",
        icon: faRulerCombined,
        link: "/blogs/gsm-deckle-knife-limits",
        datePublished: "2025-07-20",
        keywords: "GSM, deckle size, knife limits, paper roll planning, GSM deckle knife limits best practices, roll planning optimization, Anmatics Technologies"
    },
    {
        title: "How DecklePro Improves Yield in Paper Slitting Machines",
        description: "See how DecklePro helps maximize yield and minimize waste in slitting operations.",
        icon: faArrowUp,
        link: "/blogs/decklepro-improves-yield",
        datePublished: "2025-08-01",
        keywords: "DecklePro, yield improvement, paper slitting machines, reduce trim waste, increase yield in slitting, deckle matching software benefits, Anmatics Technologies"
    },
    {
        title: "Deckle Matching Software: Must-Have Features for Modern Paper Mills",
        description: "Explore the essential features of deckle matching software for paper mills.",
        icon: faCogs,
        link: "/blogs/deckle-matching-software-features",
        datePublished: "2025-08-05",
        keywords: "Deckle matching software, paper mills, software features, Anmatics Technologies"
    },
    {
        title: "How a Paper Mill Reduced 18% Waste Using DecklePro",
        description: "DecklePro, paper mill optimization software, deckle matching, kraft paper mill, reduce paper waste, production efficiency.",
        icon: faPercent,
        link: "/blogs/how-reduced-18-percent-waste",
        datePublished: "2025-10-10",
        keywords: "DecklePro, paper mill optimization, reduce paper waste, production efficiency, deckle matching case study, 18% waste reduction case study, Anmatics Technologies"
    },
    {
        title: ".NET 10 Development Services",
        description: "Transform your business with .NET 10 - faster, smarter, and AI-ready. Partner with Anmatics for modern .NET solutions.",
        icon: faCode,
        link: "/blogs/dotnet-10-business-solutions",
        datePublished: "2025-11-15",
        keywords: ".NET 10, .NET development, business solutions, AI-ready, Anmatics Technologies"
    },
    {
        title: "Architecting Angular Applications for Scale: A Guide for Modern Development",
        description: "Learn practical strategies for architecting scalable Angular applications. Discover best practices for modular design, state management, lazy loading, and more.",
        icon: faProjectDiagram,
        link: "/blogs/architecting-angular-applications",
        datePublished: "2025-12-01",
        keywords: "Angular architecture, scalable Angular apps, enterprise Angular, NgRx, Signals, lazy loading, domain-driven design, shared module, Anmatics Technologies"
    },
    {
        title: "Why most SaaS applications fail and how to avoid it",
        description: "Explore the common reasons SaaS applications fail and learn practical strategies to ensure your SaaS product's success in a competitive market.",
        icon: faLightbulb,
        link: "/blogs/why-saas-products-slow-down",
        datePublished: "2025-12-10",
        keywords: "SaaS failure, SaaS scaling, SaaS performance, tech stack, Node.js, .NET Core, Angular, scalable architecture, CI/CD, signs you need an engineering partner, how to scale engineering without hiring, Anmatics Technologies"
    },
    {
        title: "7 Signs your Company Needs an Engineering Partner (Not More Employees)",
        description: "Discover the key signs your company needs a specialized engineering partner instead of hiring more developers. Learn how Anmatics accelerates product delivery and modernizes systems.",
        icon: faExplosion,
        link: "/blogs/engineering-partner-vs-hiring",
        datePublished: "2025-05-28",
        keywords: "engineering partner, software outsourcing, SaaS scaling, technical debt, module ownership, product development, Anmatics Technologies"
    },
    {
        title: "A Founder’s Guide to Building Reliable Software Without a Full In-House Team",
        description: "Learn how founders and SaaS startups can build reliable, scalable software without hiring a full in-house engineering team. Discover the benefits of engineering partners, modular architecture, QA, CI/CD, and more from Anmatics Technologies.",
        icon: faBook,
        link: "/blogs/founders-guide-reliable-software",
        datePublished: "2025-01-15",
        keywords: "founder guide, reliable software, engineering partner, SaaS, startup, modular architecture, QA, CI/CD, Node.js, .NET Core, Angular, MVP development, Anmatics Technologies, India, Gujarat, Surat, global, software outsourcing, product roadmap, technical partnership"
    }
];

const gradients = [
    "linear-gradient(135deg, #ff5f6d, #ffc371)", // Red to Orange
    "linear-gradient(135deg, #24c6dc, #514a9d)", // Teal to Purple
    "linear-gradient(135deg, #f7971e, #ffd200)", // Amber to Yellow
    "linear-gradient(135deg, #8e2de2, #4a00e0)", // Violet to Deep Blue
    "linear-gradient(135deg, #00c6ff, #0072ff)", // Light Blue to Strong Blue
    "linear-gradient(135deg, #43cea2, #185a9d)",  // Green to Blue
    "linear-gradient(135deg, #ff9966, #ff5e62)",  // Light Orange to Red
    "linear-gradient(135deg, #56ab2f, #a8e063)",  // Light Green to Bright Green
    "linear-gradient(135deg, #f46b45, #eea849)",  // Coral to Light Orange
    "linear-gradient(135deg, #1e3c72, #2a5298)"  // Dark Blue to Medium Blue
];

// Official colors for Node.js and Angular icons
const officialIconBg = {
    "Node.js: The Backbone of Scalable Web Applications in 2025": "#539e43", // Node.js green
    "Why Angular Is Still the Most Reliable Framework for Enterprise Web Applications in 2025": "#dd0031", // Angular red
};

const Blogs = () => (
    <section id="blogs" className="section blog-section position-relative overflow-hidden">
        <div className="blogs-overlay"></div>
        <Helmet>
            <title>Anmatics Blogs | Paper Manufacturing, Deckle Matching, Trim Waste Reduction, Node.js, .NET Core, Angular, SaaS Scaling</title>
            <meta name="description" content="Read expert blogs from Anmatics about deckle matching, trim waste reduction, paper roll planning, Node.js, .NET Core modernization, Angular architecture, and SaaS scaling for modern applications." />
            <meta name="keywords" content="Deckle, Deckle Matching, Deckle Match, Deckle Matching Software, Deckle Match Software, Deckle Software, Deckle app, Deckle web, Deckle technology, Kraft Paper software, Paper mill software, deckle matching, trim waste, paper manufacturing, paper roll cutting, DecklePro, paper mill software, yield improvement, GSM, knife limits, order management, reporting, how to reduce trim waste, improve paper mill efficiency, reel slitting software, knife setup software, deckle software India, kraft paper mill planning, best deckle software, trim waste calculator, slitting optimization tool, Node.js, scalable web applications, Node.js 2025, Angular, Angular 2025, Architecting Angular, Angular architecture, scalable Angular applications, .NET Core modernization, legacy system upgrade, SaaS scaling, SaaS performance, Anmatics Technologies" />
            <link rel="canonical" href="https://www.anmatics.com/blogs" />

            {/* Open Graph / Social meta */}
            <meta property="og:title" content="Anmatics Blogs | Paper Manufacturing, Deckle Matching, Trim Waste Reduction, Node.js, .NET Core, Angular, SaaS Scaling" />
            <meta property="og:description" content="Expert articles on deckle matching, trim waste reduction, paper roll planning, Node.js scalability, .NET Core modernization, Angular architecture, and SaaS scaling from Anmatics Technologies." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.anmatics.com/blogs" />
            <meta property="og:image" content="https://www.anmatics.com/anmatics_logo.png" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Anmatics Blogs | Deckle Matching, Node.js, .NET Core, Angular, SaaS Scaling" />
            <meta name="twitter:description" content="Practical guides and case studies for paper mills, plus engineering deep-dives: Node.js scaling, .NET Core modernization, and architecting Angular apps for scale." />
            <meta name="twitter:image" content="https://www.anmatics.com/anmatics_logo.png" />

            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Blog",
                    "name": "Anmatics Blog",
                    "url": "https://www.anmatics.com/blogs",
                    "description": "Expert articles on deckle matching, trim waste reduction, paper mill planning, Node.js, .NET Core modernization, Angular architecture, and SaaS scaling from Anmatics Technologies.",
                    "blogPost": blogs.map(blog => ({
                        "@type": "BlogPosting",
                        "headline": blog.title,
                        "description": blog.description,
                        "image": "https://www.anmatics.com/anmatics_logo.png",
                        "author": {
                            "@type": "Organization",
                            "name": "Anmatics Technologies"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "Anmatics",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://www.anmatics.com/anmatics_logo.png"
                            }
                        },
                        "datePublished": blog.datePublished,
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": `https://www.anmatics.com${blog.link}`
                        },
                        "keywords": blog.keywords
                    }))
                })}
            </script>
        </Helmet>
        <div className="container" data-aos="fade-up">
            <div className="section-header mb-4 text-center">
                <h3 className="contact-title gradient-title">Our Blogs</h3>
            </div>
            <div className="row">
                {blogs.map((blog, idx) => {
                    // Use official color for Node.js and Angular, else fallback to gradient
                    const bgColor = officialIconBg[blog.title] || gradients[idx % gradients.length];
                    const iconColor =
                        blog.icon === faNodeJs ? "#fff" :
                            blog.icon === faAngular ? "#fff" :
                                undefined;
                    return (
                        <article className="col-lg-4 col-md-6 mb-4" key={idx} itemScope itemType="https://schema.org/BlogPosting">
                            <Helmet>
                                <title>{blog.title} | Anmatics Blog</title>
                                <meta name="description" content={blog.description} />
                                <meta name="keywords" content={blog.keywords} />
                                <link rel="canonical" href={`https://www.anmatics.com${blog.link}`} />
                                <meta property="og:title" content={blog.title} />
                                <meta property="og:description" content={blog.description} />
                                <meta property="og:type" content="article" />
                                <meta property="og:url" content={`https://www.anmatics.com${blog.link}`} />
                            </Helmet>
                            <div className="card h-100 blog-card">
                                <div className="card-body d-flex flex-column align-items-center blog-card-body">
                                    <div
                                        className="blog-icon-wrapper"
                                        style={{
                                            background: bgColor,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={blog.icon}
                                            size="2x"
                                            className="blog-icon colorful-icon"
                                            aria-hidden="true"
                                            style={iconColor ? { color: iconColor } : {}}
                                        />
                                    </div>
                                    <h5 className="card-title fw-semibold text-center futuristic-text" itemProp="headline">{blog.title}</h5>
                                    <p className="card-text text-center futuristic-subtext" itemProp="description">{blog.description}</p>
                                    <meta itemProp="author" content="Anmatics Technologies" />
                                    <meta itemProp="datePublished" content={blog.datePublished} />
                                    <a href={blog.link} className="btn btn-gradient mt-auto rounded-pill shadow-sm" itemProp="url">
                                        Read More
                                    </a>
                                </div>
                            </div>
                        </article>
                    );
                })}
            </div>
            <p className="text-center mt-5 fs-6">
                Looking for a powerful solution to reduce trim waste and automate deckle planning?{" "}
                <a href="/product-details" className="text-link-gradient">
                    Explore DecklePro – Our Smart Deckle Matching Software
                </a>.
            </p>
        </div>
    </section>
);

export default Blogs;